import { LoadingButton } from "@mui/lab";
import { Box, Typography, Button } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import useGetGgpsLogin from "src/shared/data-access/ggpsLogin/useGetGgpsLogin";
import { useGgpsNew } from "src/welcome/data-access/useGgpsNew";
import { OAuthModes } from "src/welcome/types";

export default function CompanyNameApproverLogin() {
  const { t } = useTranslation();
  const { mutate: goToTaxis, isLoading: isLoadingGgpsLogin } =
    useGetGgpsLogin();
  const { mutate: mutateNew, isLoading: isLoadingGgpsLoginNew } =
    useGgpsNew();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        maxWidth: "80vw",
        mx: "auto",
      }}
    >
      <Typography variant="h4" component="h1">
        {t("Υπηρεσία διαχείρισης αιτημάτων Επωνυμίας / ΔΤ")}
      </Typography>
      <Typography variant="h6" component="h2">
        {t(
          "Για την είσοδο στην υπηρεσία διαχείρισης αιτημάτων παραχώρησης Επωνυμίας / ΔΤ είναι απαραίτητη η διασταύρωση των στοιχείων σας μέσω ΑΑΔΕ. Πιέστε το κουμπί για να μεταβείτε στην ΑΑΔΕ (Taxis).",
        )}
      </Typography>
      <LoadingButton
        loading={isLoadingGgpsLogin || isLoadingGgpsLoginNew}
        sx={{ alignSelf: "center" }}
        variant="contained"
        onClick={() =>
          import.meta.env.VITE_OAUTH2_ACTIVATED === "true"
            ? mutateNew({ mode: OAuthModes.LOGIN_COMPANY_NAME_APPROVER })
            : goToTaxis({ mode: "companyNameApprover" })
        }
      >
        {t("Είσοδος μέσω TAXIS / ΑΑΔΕ")}
      </LoadingButton>
    </Box>
  );
}
